var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1269 2.72878L8.73024 0.0597534C8.61986 0.0199402 8.50613 0 8.39045 0C8.27424 0 8.15889 0.0201416 8.04798 0.0603577L0.677832 2.72939C0.279498 2.87387 0 3.25233 0 3.67611V9.99997C0 11.4118 0.455066 12.8239 1.3235 14.1968C1.98918 15.2491 2.9157 16.281 4.0629 17.2641C5.98105 18.9078 7.88429 19.8559 7.96426 19.8955C8.10498 19.9651 8.2598 20 8.41281 20C8.56354 20 8.71527 19.9662 8.85438 19.8985C8.93434 19.8595 10.8367 18.9262 12.7567 17.289C13.905 16.3099 14.8176 15.2779 15.4838 14.222C16.3519 12.8461 16.7846 11.4257 16.7846 9.99997V3.67611C16.7847 3.25166 16.5262 2.87273 16.1269 2.72878ZM1.61133 9.99527V4.42907C1.61133 4.21718 1.74117 4.02792 1.94037 3.95568L8.20522 1.67652C8.26108 1.65631 8.32519 1.64141 8.39233 1.64141V10H15.2211C15.2215 10 15.2219 10.0091 15.2219 10.0149C15.2206 11.8363 14.3032 13.6414 12.4956 15.3991C11.0841 16.7717 9.48031 17.7513 8.65538 18.2134C8.57891 18.2563 8.45954 18.2766 8.3924 18.2766C8.3924 18.1199 8.3924 10.0868 8.3924 9.99742L1.61133 9.99527Z",
    fill: "#565656",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightShield);
export default __webpack_public_path__ + "static/media/light-shield.a88f9571.svg";
export { ForwardRef as ReactComponent };